export class PaymentDetails {
    paid?: number;
    unpaid?: number;
    constructor(paid: number, unpaid: number) {
        this.paid = paid;
        this.unpaid = unpaid;
    }
  }